import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClientiPort } from './clienti.port';
import { Cliente, CreateClienteDto, UpdateClienteDto } from '../../models/clienti.model';
import {AttoriQueryParams, AttoriPagedResponse, CreateAttoreDto} from '../../models/attori.model';
import { environment } from '../../../environments/environment';
import {TenantService} from '../tenant.service';

@Injectable({ providedIn: 'root' })
export class ClientiHttpService implements ClientiPort {
  private http = inject(HttpClient);
  private tenantService = inject(TenantService);
  private base = `${environment.apiBaseUrl || ''}/${this.tenantService.tenant}/attori`;

  getList(): Observable<Cliente[]> {
    const params = new HttpParams().set('isCliente', 'true');
    return this.http.get<any>(this.base, { params }).pipe(
      map((res: any) => Array.isArray(res) ? res : (res?.content ?? []))
    );
  }

  getListPaginated(params: AttoriQueryParams): Observable<AttoriPagedResponse<Cliente>> {
    let httpParams = new HttpParams()
      .set('isCliente', 'true')
      .set('page', String(params.page ?? 0))
      .set('size', String(params.size ?? 20));
    if (params.wordSearch) httpParams = httpParams.set('wordSearch', params.wordSearch);
    if (params.sort) params.sort.forEach(s => { httpParams = httpParams.append('sort', s); });
    return this.http.get<any>(this.base, { params: httpParams }).pipe(
      map((res: any) => ({
        content: Array.isArray(res) ? res : (res?.content ?? []),
        totalElements: res?.totalElements ?? 0,
        totalPages: res?.totalPages ?? 0,
        pageIndex: res?.pageable?.pageNumber ?? params.page ?? 0,
      }))
    );
  }

  getById(id: number): Observable<Cliente> {
    return this.http.get<Cliente>(`${this.base}/${id}`);
  }

  create(dto: CreateClienteDto): Observable<Cliente> {
    return this.http.post<Cliente>(this.base, dto);
  }

  update(id: number, changes: UpdateClienteDto): Observable<Cliente> {
    return this.http.patch<Cliente>(`${this.base}/${id}`, changes);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }
  updateAttore(id: number, dto: Partial<CreateAttoreDto>): Observable<void> {
    return this.http.patch<void>(
      `${environment.apiBaseUrl || ''}/${this.tenantService.tenant}/attori/${id}`,
      dto
    );
  }
  createRecapito( dto: any): Observable<void> {
    return this.http.post<void>(`${this.base}/recapito`, dto);
  }

  updateRecapito(id: number, dto: any): Observable<void> {
    return this.http.patch<void>(`${this.base}/recapito/${id}`, dto);
  }

  deleteRecapito(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/recapito/${id}`);
  }

  createConto(idAttore: number, dto: any): Observable<void> {
    return this.http.post<void>(`${this.base}/conto`, dto);
  }

  updateConto(id: number, dto: any): Observable<void> {
    return this.http.patch<void>(`${this.base}/conto/${id}`, dto);
  }

  deleteConto(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/conto/${id}`);
  }
}
